import { render, staticRenderFns } from "./wj.vue?vue&type=template&id=2c1658a2&"
import script from "./wj.vue?vue&type=script&lang=js&"
export * from "./wj.vue?vue&type=script&lang=js&"
import style0 from "./wj.vue?vue&type=style&index=0&%40scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports